export default {
  'setting.name': 'Cài đặt',
};
